"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _page = _interopRequireDefault(require("@atlaskit/icon/core/page"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PageFilledIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M5 3.99C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" fill="inherit" rx="1"/><rect width="8" height="2" x="8" y="9" fill="inherit" rx="1"/><rect width="4" height="2" x="8" y="12" fill="inherit" rx="1"/></g></svg>`
}, props, {
  newIcon: _page.default
}));
PageFilledIcon.displayName = 'PageFilledIcon';
var _default = exports.default = PageFilledIcon;